import genererContactTiers from '@/services/import/contact/genererContactTiers';
import store from '@/store/store';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import {
  TIERS_TYPE_CLIENT, TIERS_SOUS_TYPE_AUCUN,
} from '@/configuration/tiers/tiersConf';
import { getAll as getAllTiers } from '@/api/tiers/index';
import { getAllWithTiers } from '@/api/contacts/index';
import createAll from '@/api/contactTiers/index';
import { columns } from '@/services/import/contact/templateContactTiers';
import i18n from '@/i18n/index';

export function ErrorContactTiersTranslate(errors) {
  if (!errors || !Array.isArray(errors)) return [];
  return errors.map(error => {
    if (error.endsWith('_IS_REQUIRED')) {
      return i18n.t('importationContactsTiers.errors.requiredPropertie', { label: error.split('_')[0] });
    }
    if (error.includes('_MAX_LENGTH_')) {
      return i18n.t('importationContactsTiers.errors.maxLengthPropertie', { label: error.split('_')[0], length: error.split('_')[error.split('_').length - 1] });
    }
    if (error.includes('_CLIENT_NOT_FOUND')) {
      return i18n.t('importationContactsTiers.errors.clientNotFound', { name: error.split('_')[0] });
    }

    if (error.includes('_CONTACT_NOT_FOUND')) {
      return i18n.t('importationContactsTiers.errors.contactNotFound', { name: error.split('_')[0] });
    }
    switch (error) {
      default:
        return 'Un problème est survenu';
    }
  }).join(' - ');
}

function validationLigne(ligne, tiers, contacts) {
  const error = {
    numLigne: ligne.numLigne,
    errors: [],
  };
  const tier = tiers.find(t => t.referenceExterne === ligne.tiersId);
  if (ligne.tiersId && !tier) error.errors.push(`${ligne.tiersId}_CLIENT_NOT_FOUND`);

  const contact = contacts.find(t => t.referenceExterne === ligne.contactId);
  if (ligne.contactId && !contact) error.errors.push(`${ligne.contactId}_CONTACT_NOT_FOUND`);

  columns.forEach(column => {
    const columnErrors = column.checkValue(ligne[column.key]);
    if (columnErrors.length > 0) error.errors = error.errors.concat(columnErrors);
  });

  if (error.errors.length > 0) throw error;
}

export async function makeContactTiersGenerated(file) {
  const lignes = file[0];
  const contactsTiers = [];
  const errors = [];

  const tiers = (await getAllTiers({
    query: {
      societeId: store.getters['societe/societeActiveId'],
      type: TIERS_TYPE_CLIENT,
      sousType: [TIERS_SOUS_TYPE_AUCUN],
    },
    limit: NO_PAGINATION,
  })).data.result.items;

  const contacts = (await getAllWithTiers({
    query: {
      societeId: store.getters['societe/societeActiveId'],
    },
    limit: NO_PAGINATION,
  })).data.result.items;

  // saut de la premiere vu qu'on a 2 lignes d'entete
  for (let i = 1; i < lignes.length; i += 1) {
    try {
      validationLigne(lignes[i], tiers, contacts);
    } catch (e) {
      errors.push(e);
    }
  }
  if (errors.length > 0) {
    errors.unshift({ total: lignes.length - 1, totalErrors: errors.length });
    throw errors;
  }

  // saut de la premiere vu qu'on 2 lignes d'entete
  for (let i = 1; i < lignes.length; i += 1) {
    const contactTiers = genererContactTiers(lignes[i], tiers, contacts);
    contactsTiers.push(contactTiers);
  }

  return contactsTiers;
}

export async function makeContactTiersImport(contactsTiers, modeTest) {
  await createAll(contactsTiers, modeTest, true);
}
